import { render, staticRenderFns } from "./MiniProductView.vue?vue&type=template&id=795c507c&"
import script from "./MiniProductView.vue?vue&type=script&lang=js&"
export * from "./MiniProductView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports